function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import TouchPan from '../../directives/TouchPan.js';
import DarkMixin from '../../mixins/dark.js';
import ListenersMixin from '../../mixins/listeners.js';
import { slot } from '../../utils/slot.js';
import { cacheWithFn } from '../../utils/cache.js';
var slotsDef = [['left', 'center', 'start', 'width'], ['right', 'center', 'end', 'width'], ['top', 'start', 'center', 'height'], ['bottom', 'end', 'center', 'height']];
export default Vue.extend({
  name: 'QSlideItem',
  mixins: [DarkMixin, ListenersMixin],
  props: {
    leftColor: String,
    rightColor: String,
    topColor: String,
    bottomColor: String
  },
  directives: {
    TouchPan: TouchPan
  },
  computed: {
    langDir: function langDir() {
      return this.$q.lang.rtl === true ? {
        left: 'right',
        right: 'left'
      } : {
        left: 'left',
        right: 'right'
      };
    }
  },
  methods: {
    reset: function reset() {
      this.$refs.content.style.transform = 'translate(0,0)';

      this.__emitSlide(this.__showing, 0, true);
    },
    __emitSlide: function __emitSlide(side, ratio, isReset) {
      this.qListeners.slide !== void 0 && this.$emit('slide', {
        side: side,
        ratio: ratio,
        isReset: isReset
      });
    },
    __pan: function __pan(evt) {
      var _this = this;

      var node = this.$refs.content;

      if (evt.isFirst) {
        this.__dir = null;
        this.__size = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        };
        this.__scale = 0;
        node.classList.add('no-transition');
        slotsDef.forEach(function (slot) {
          if (_this.$scopedSlots[slot[0]] !== void 0) {
            var _node = _this.$refs[slot[0] + 'Content'];
            _node.style.transform = 'scale(1)';
            _this.__size[slot[0]] = _node.getBoundingClientRect()[slot[3]];
          }
        });
        this.__axis = evt.direction === 'up' || evt.direction === 'down' ? 'Y' : 'X';
      } else if (evt.isFinal) {
        node.classList.remove('no-transition');

        if (this.__scale === 1) {
          node.style.transform = "translate".concat(this.__axis, "(").concat(this.__dir * 100, "%)");
          this.timer = setTimeout(function () {
            _this.$emit(_this.__showing, {
              reset: _this.reset
            });

            _this.$emit('action', {
              side: _this.__showing,
              reset: _this.reset
            });
          }, 230);
        } else {
          node.style.transform = 'translate(0,0)';

          this.__emitSlide(this.__showing, 0, true);
        }

        return;
      } else {
        evt.direction = this.__axis === 'X' ? evt.offset.x < 0 ? 'left' : 'right' : evt.offset.y < 0 ? 'up' : 'down';
      }

      if (this.$scopedSlots.left === void 0 && evt.direction === this.langDir.right || this.$scopedSlots.right === void 0 && evt.direction === this.langDir.left || this.$scopedSlots.top === void 0 && evt.direction === 'down' || this.$scopedSlots.bottom === void 0 && evt.direction === 'up') {
        node.style.transform = 'translate(0,0)';
        return;
      }

      var showing, dir, dist;

      if (this.__axis === 'X') {
        dir = evt.direction === 'left' ? -1 : 1;
        showing = dir === 1 ? this.langDir.left : this.langDir.right;
        dist = evt.distance.x;
      } else {
        dir = evt.direction === 'up' ? -2 : 2;
        showing = dir === 2 ? 'top' : 'bottom';
        dist = evt.distance.y;
      }

      if (this.__dir !== null && Math.abs(dir) !== Math.abs(this.__dir)) {
        return;
      }

      if (this.__dir !== dir) {
        ['left', 'right', 'top', 'bottom'].forEach(function (d) {
          if (_this.$refs[d] !== void 0) {
            _this.$refs[d].style.visibility = showing === d ? 'visible' : 'hidden';
          }
        });
        this.__showing = showing;
        this.__dir = dir;
      }

      this.__scale = Math.max(0, Math.min(1, (dist - 40) / this.__size[showing]));
      node.style.transform = "translate".concat(this.__axis, "(").concat(dist * dir / Math.abs(dir), "px)");
      this.$refs["".concat(showing, "Content")].style.transform = "scale(".concat(this.__scale, ")");

      this.__emitSlide(showing, this.__scale, false);
    }
  },
  render: function render(h) {
    var _this2 = this;

    var content = [],
        slots = {
      left: this.$scopedSlots[this.langDir.right] !== void 0,
      right: this.$scopedSlots[this.langDir.left] !== void 0,
      up: this.$scopedSlots.bottom !== void 0,
      down: this.$scopedSlots.top !== void 0
    },
        dirs = Object.keys(slots).filter(function (key) {
      return slots[key] === true;
    });
    slotsDef.forEach(function (slot) {
      var dir = slot[0];

      if (_this2.$scopedSlots[dir] !== void 0) {
        content.push(h('div', {
          ref: dir,
          "class": "q-slide-item__".concat(dir, " absolute-full row no-wrap items-").concat(slot[1], " justify-").concat(slot[2]) + (_this2[dir + 'Color'] !== void 0 ? " bg-".concat(_this2[dir + 'Color']) : '')
        }, [h('div', {
          ref: dir + 'Content'
        }, _this2.$scopedSlots[dir]())]));
      }
    });
    content.push(h('div', {
      ref: 'content',
      key: 'content',
      staticClass: 'q-slide-item__content',
      directives: dirs.length > 0 ? cacheWithFn(this, 'dir#' + dirs.join(''), function () {
        var modifiers = {
          prevent: true,
          stop: true,
          mouse: true
        };
        dirs.forEach(function (dir) {
          modifiers[dir] = true;
        });
        return [{
          name: 'touch-pan',
          value: _this2.__pan,
          modifiers: modifiers
        }];
      }) : null
    }, slot(this, 'default')));
    return h('div', {
      staticClass: 'q-slide-item q-item-type overflow-hidden',
      "class": this.isDark === true ? 'q-slide-item--dark q-dark' : '',
      on: _objectSpread({}, this.qListeners)
    }, content);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer);
  }
});